import { render, staticRenderFns } from "./pedidosCliente.vue?vue&type=template&id=6ab97fac&"
import script from "./pedidosCliente.vue?vue&type=script&lang=js&"
export * from "./pedidosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports